import { ModelMetadataView } from '../../features/ModelView/ModelMetadataView/ModelMetadataView';
import { useIsAdmin } from '../../hooks/useIsAdmin';
import { useIsOwnerOrAdmin } from '../../hooks/useIsOwnerOrAdmin';
import { DeleteModel } from './DeleteButton/DeleteModel';
import { ExternalSimulationUpload } from './ExternalSimulationUpload/ExternalSimulationUpload';
import { useAnalogueModelHasScenario } from './ExternalSimulationUpload/hooks/useAnalogueModelHasScenario';
import * as Styled from './ModelView.styled';

export const ModelView = () => {
  const hasScenarios = useAnalogueModelHasScenario();
  const isAdmin = useIsAdmin();
  const isOwnerOrAdmin = useIsOwnerOrAdmin();
  return (
    <>
      <Styled.MetadataWrapper>
        <ModelMetadataView />
        {isAdmin && isOwnerOrAdmin && !hasScenarios ? (
          <div className="card-actions-row">
            <DeleteModel />
            <ExternalSimulationUpload />
          </div>
        ) : isOwnerOrAdmin ? (
          <DeleteModel />
        ) : null}
      </Styled.MetadataWrapper>
    </>
  );
};
